


















import { Prop } from 'vue-property-decorator';
import Component, { mixins } from 'vue-class-component';
import AnimatedNumber from '../atoms/animated-number.vue';
import { ARIA_REFS, getMultiRefsStringified } from '@/config/accessibility';
import { namespace } from 'vuex-class';
import TooltipAble from '../../mixins/tooltip';
import { Modules } from '@/store/store';
import { SubBrand } from '@/store/modules/themes';

const configModule = namespace(Modules.config);
const themeModule = namespace(Modules.themes);

@Component({
  name: 'eqweb-battery-label',
  components: { AnimatedNumber },
})
export default class Battery extends mixins(TooltipAble) {
  @Prop({ type: Number, required: true })
  private readonly chargingValue!: number;

  @Prop({ type: Number })
  private readonly chargingValueStart: number | undefined;

  @themeModule.Getter('subBrand')
  private readonly subBrand!: SubBrand;

  @configModule.Getter('hasBatteryStartSlider')
  private readonly hasBatteryStartSlider!: boolean;

  private get ARIA_REFS() {
    return ARIA_REFS;
  }

  private get labelAriaDescribedBy() {
    return getMultiRefsStringified(
      ARIA_REFS.BATTERY_HEADLINE,
      ARIA_REFS.BATTERY_CHARGER_LABEL,
      ARIA_REFS.BATTERY_CHARGING_OPTIONS,
      ARIA_REFS.BATTERY_MILEAGE,
      ARIA_REFS.BATTERY_INFOTEXT,
    );
  }
}
